import * as React from 'react';
import { cn } from '@/lib/utils';

export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'flex h-9 w-full rounded-lg border border-border-strong bg-surface px-3 py-1 text-sm text-ink transition-colors',
      'placeholder:text-ink-subtle',
      'focus-visible:border-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/25',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'aria-[invalid=true]:border-critical aria-[invalid=true]:focus-visible:ring-critical/25',
      className,
    )}
    {...props}
  />
));

Input.displayName = 'Input';
